import { Row, Col, Button, ButtonGroup } from 'react-bootstrap';
import { handleFieldChange } from "../../Utils";
import { Component } from 'react';

import React from 'react';

import SelectWrap from "../../components/SelectWrap";
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Table from './components/Table';
import Form from './components/Form';
import Icon from "../../components/Icon";
import API from '../../services/API';

import sort from 'array-sort';

class Domains extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            isShowForm: false,
            sortParam: null,
            sortOrder: 1,
            domains: [],
            domain: {},
            distinct: {
                types: []
            },
            filters: {
                typeId: null
            }
        };

        this.handleAddBtnClick = this.handleAddBtnClick.bind(this);
        this.handleRemoveBtnClick = this.handleRemoveBtnClick.bind(this);
        this.handleFormHide = this.handleFormHide.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleSort = this.handleSort.bind(this);

        this.handleFieldChange = handleFieldChange.bind(this);
    }

    componentDidMount() {
        this.loadDomains();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (JSON.stringify(prevState.filters) !== JSON.stringify(this.state.filters)) {
            return this.loadDomains();
        }
    }

    componentWillUpdate(nextProps, nextState) {
        const { domains, sortParam, sortOrder } = nextState;

        if(this.state.sortParam != sortParam || this.state.sortOrder != sortOrder) {
            this.sortReport(domains, sortParam, sortOrder);

            this.setState({ domains });
        }
    }

    sortReport(domains, sortParam, sortOrder) {
        sort(domains, sortParam, { reverse: sortOrder === 1 });
    }

    async loadDomains() {
        this.setState({ isLoading: true });

        const filters = Object.fromEntries(
            Object.entries(this.state.filters)
                .filter(([ key, value ]) => Boolean(value) && value.length > 0)
        )

        const [ domains, types ] = await Promise.all([
            API.Domains.get(filters),
            API.Domains.types()
        ])

        this.setState({ domains, distinct: { types }, isLoading: false });
    }

    handleAddBtnClick() {
        this.setState({ isShowForm: true });
    }

    handleFormHide() {
        this.setState({ isShowForm: false, domain: {} });
    }

    handleFormSubmit(domain, update) {
        this.setState({
            domain: {},
            isShowForm: false,
            isLoading: true
        });

        if (update) {
            API.Domains.update(domain.id, domain).then(() => this.loadDomains());
        } else {
            API.Domains.save(domain).then(() => this.loadDomains());
        }
    }

    handleRemoveBtnClick(id) {
        this.setState({ isLoading: true });

        API.Domains.remove(id).then(() => this.loadDomains());
    }

    handleSort(param) {
        const { sortParam, sortOrder } = this.state;

        if (sortParam === null) this.setState({ sortParam: param });
        else if (param === sortParam) this.setState({ sortOrder: sortOrder * -1 });
        else this.setState({ sortParam: param, sortOrder: 1 });
    }

    getForm() {
        if (this.state.isShowForm || Object.keys(this.state.domain).length) {
            return <Form
                domain={this.state.domain}
                onSubmit={this.handleFormSubmit}
                onFormHide={this.handleFormHide} />;
        }
    }

    render() {
        return (
            <Container loading={this.state.isLoading}>
                <Heading title="Domains"/>

                <Row>
                    <Col lg={3}>
                        <SelectWrap
                            values={this.state.distinct.types}
                            label="Types:"
                            name="filters.typeId"
                            onChange={this.handleFieldChange}
                            value={this.state.filters.typeId}
                            multi
                        />
                    </Col>
                </Row>

                <Row>
                    <Col lg={12}>
                        <ButtonGroup className="pull-right m-b-15">
                            <Button bsStyle="success" onClick={this.handleAddBtnClick}><Icon name="plus" /> Add</Button>
                        </ButtonGroup>
                    </Col>
                </Row>

                {this.getForm()}

                <Table domains={this.state.domains} onEdit={(domain) => this.setState({ domain })} onRemove={this.handleRemoveBtnClick} onSort={this.handleSort}/>
            </Container>
        );
    }
}

export default Domains;



// WEBPACK FOOTER //
// ./src/scenes/Domains/index.js